import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const ChartVertical = ({ width, height, color }: IProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width ?? 24}
            height={height ?? 24}
            viewBox='0 0 24 24'
            fill='none'
        >
            <path
                d='M10.4096 3.99365C9.96797 3.99365 9.60957 4.35205 9.60957 4.79365V18.3937H13.6096V4.79365C13.6096 4.35205 13.2512 3.99365 12.8096 3.99365H10.4096ZM0.80957 5.59365V21.5937H20.8096V19.9937H2.40957V5.59365H0.80957ZM16.0096 5.59365C15.568 5.59365 15.2096 5.95205 15.2096 6.39365V18.3937H19.2096V6.39365C19.2096 5.95205 18.8512 5.59365 18.4096 5.59365H16.0096ZM4.80957 8.79365C4.36797 8.79365 4.00957 9.15205 4.00957 9.59365V18.3937H8.00957V9.59365C8.00957 9.15205 7.65117 8.79365 7.20957 8.79365H4.80957Z'
                fill={color ?? colors.grey[50]}
            />
        </svg>
    )
}

export default React.memo(ChartVertical)
